import React, { Component, PropTypes } from "react"
import { Button, Icon, Upload, Table, message, Select, InputNumber,Modal } from "antd"
import cx from "classnames"
import CModal from "../../CModal"
import "./Index.scss"
import UploadProgressModal from "./UploadProgressModal"
import DeleteModal from "./DeleteModal"
import FailedModal from "./FailedModal"
import ValidateModal from "./ValidateModal"
const Dragger = Upload.Dragger
import { Provider, observer } from "mobx-react"
import { action } from "mobx"
import GroupList from "./GroupList"
import stores from "./stores"
import { disposeFileSize, disposeFilename } from "app/vendor/util"
import { getCurrentApp } from "app/api/localTools"
import QuitModal from "./QuitModal"

const { Option } = Select

const ObserverStar = observer(({ record, ...rest }) => {
  const color = record.reference ? "#f8b62d" : "#ddd"
  return <Icon style={{ color, fontSize: "16px" }} type="star" {...rest} />
})

@observer
export default class UploadModal extends Component {
  static propTypes = {
    type: PropTypes.oneOf(["singleGroup", "multiGroups"])
  }

  static defaultProps = {
    type: "multiGroups"
  }

  constructor(props) {
    super(props)
    this.state = {
      errorVisible: false,
      errorMessage:''
    }
  }

  columns = [{
    title: "文件名",
    dataIndex: "name",
    width: '50%',
    render: (text, file) => {
      return (
        <a
          style={{
            color: ((getCurrentApp() === 'pgd' &&
              this.props.verifyLimsPgdFamily) &&
              !file.file.matched) ? 'red' : 'unset'
          }}
        >
          {disposeFilename(text, 25).filename}
        </a>
      )
    }
  }, {
    title: "文件大小",
    dataIndex: "size",
    width: '12%',
    render: byteCount => {
      return (
        <span>
          {disposeFileSize(byteCount)}
        </span>
      )
    }
  }, {
    title: "操作",
    width: 60,
    dataIndex: "progress",
    render: (progress, file, index) =>
      <Icon type="cross-circle" onClick={() => { this.deleteFile(file) }} />
  }]

  state = {
    uploading: false,
    failedOpened: true,
    quitOpened: false,
    validateOpened: false,
  }
  // 接收文件
  beforeUpload = (file) => {
    const { verifyLimsPgdFamily } = this.props
    const { allowSuffix } = stores.manager.currentTask
    if (allowSuffix !== "*") {       // 验证上传文件的后缀是
      const fileType = file.name.split(".").pop()
      const acceptable = new RegExp(fileType).test(allowSuffix)
      if (!acceptable) {
        message.error("请您上传测序结果文件^.^")
        return false
      }
    }

    let { addFile, selectedGroup, groups, checkDuplicate } = stores.manager.currentTask
   
    // 门槛条件
    if (groups.slice().length === 0) {
      message.error("请您上传文件前先建立组")
      return false
    }
    if (selectedGroup === undefined) {
      message.error("请您上传文件前先选中分组")
      return false
    }
    if (file.size === 0) {
      message.error("不能上传空文件 " + file.name)
      return false
    }
    if (checkDuplicate(selectedGroup, file)) {
      message.error("上传文件重复 " + file.name + ", 请重新选择 ")
      return false
    }
    // if (getCurrentApp() === 'pgd') {
    //   if (!selectedGroup.judgeDataReady) {
    //     message.error("正在获取对比所需文库号，请稍后重试")
    //     return false
    //   }
    // }
    if (verifyLimsPgdFamily && getCurrentApp() === 'pgd') {
      file.matched = ((selectedGroup && selectedGroup.judgeData) || []).some(function(info) {
        return info.libraryCode === file.name.split('_')[0]
      })
    }

    addFile(file)
    return false
  }

  onUpdateShortName(event, index) {
    stores.manager.currentTask.updateShortName(index, event.target.value)
  }

  deleteFile(file) {
    stores.manager.currentTask.removeFile(file)
  }

  switchReference(file) {
    stores.manager.currentTask.selectedGroup.switchReference(file)
  }

  deleteTask = task => {
    stores.manager.currentTask.removeTask(this.state.targetTask)
      .then(null, error => message.error(error))
    this.setState({
      deleteOpened: false
    })
  }

  @action
  onUpload = () => {
    const { manager: { currentTaskId } } = stores
    if (getCurrentApp() === 'azf' && currentTaskId === '301') {
      const noReference = stores.manager.currentTask.validatePgmReference()
      if (noReference.length > 0) {
        this.openValidateModal(noReference)
      } else {
        this.startUpload()
      }
    } else {
      this.startUpload()
    }
  }

  @action continueUpload = () => {
    this.startUpload()
  }

  @action startUpload = (type) => {
    stores.manager.currentTask.startUpload(type)
      .then(() => {
        this.setState({
          uploading: true
        })
      }, error => {
        message.error(error)
      })
  }

  @action
  componentWillMount() {
    stores.manager.addTask(this.props.info)

    if (getCurrentApp() === "azf") {
      this.columns.splice(-1, 0, {
        title: "设为参照",
        dataIndex: "reference",
        width: 120,
        render: (reference, file, index) => {
          return (
            <ObserverStar
              record={file}
              onClick={() => this.switchReference(file)}
            />
          )
        }
      })
    }
    if (getCurrentApp() === 'pgs') {
      this.columns.splice(2, 0, {
        title: "标记分子",
        dataIndex: "tracer",
        render: (text, file) => {
          return (
            <InputNumber
              min={0}
              max={300}
              onChange={(e) => this.addTrace(e, file)}
              value={this.state[file.groupInfo.name + file.name]}
            />
          )
        }
      })
    }

    if (getCurrentApp() === 'ecs') {
      this.columns.splice(2, 0, {
        title: "状态",
        dataIndex: "state",
        render: (text, file) => {
          return (
            <Select
              value={this.state[file.groupInfo.name + file.name + 'sampleType']}
              placeholder="请选择"
              style={{ width: 70 }}
              onChange={(e) => this.selectSampleType(e, file)}
            >
              <Option value="case">case</Option>
              <Option value="control">control</Option>
            </Select>
          )
        }
      }, {
        title: "性别",
        dataIndex: "sex",
        render: (text, file) => {
          return (
            <Select
              value={this.state[file.groupInfo.name + file.name + 'sampleSex']}
              placeholder="请选择"
              style={{ width: 70 }}
              onChange={(e) => this.selectSampleSex(e, file)}
            >
              <Option value="male">男</Option>
              <Option value="female">女</Option>
            </Select>
          )
        }
      }, {
        title: "单端/双端",
        dataIndex: "paired",
        render: (text, file) => {
          return (
            <Select
              value={this.state[file.groupInfo.name + file.name + 'paired']}
              placeholder="请选择"
              style={{ width: 70 }}
              onChange={(e) => this.addPaired(e, file)}
            >
              <Option value="1">单端</Option>
              <Option value="2">双端</Option>
            </Select>
          )
        }
      })
    }

  }

  @action
  closeModal = (type) => {
    const { manager: { currentTask } } = stores

    if (currentTask.filesCount > 0) {
      this.setState({
        quitOpened: true
      })
    } else {
      this.closeUploadModule()
    }
  }

  openValidateModal = (noReference) => {
    this.setState({
      noReference,
      validateOpened: true
    })
  }
  showErrorModal = (type) => {
    stores.manager.currentTask.errorVisible=false
    stores.manager.currentTask.errorMessage=''
    this.setState({
      errorVisible:false,
      errorMessage:''
    })
    if(type === 1){
      this.startUpload(1)
    }
  }

  openDeleteModal = (task) => {
    this.setState({
      targetTask: task,
      deleteOpened: true
    })
  }

  @action
  addTrace = (e, file) => {
    this.setState({
      [file.groupInfo.name + file.name]: e
    })
    file.tracer = e
  }

  addPaired = (e, file) => {
    this.setState({
      [file.groupInfo.name + file.name + 'paired']: e
    })
    file.paired = e === '1' ? 1 : 2
  }

  selectSampleType = (e, file) => {
    this.setState({
      [file.groupInfo.name + file.name + 'sampleType']: e
    })
    file.sampleType = e
  }

  selectSampleSex = (e, file) => {
    this.setState({
      [file.groupInfo.name + file.name + 'sampleSex']: e
    })
    file.sex = e
  }

  closeUploadModule = () => {
    const { onCancel } = this.props
    const { manager: { clearTasks } } = stores
    onCancel()
    clearTasks()
  }

  componentDidMount() {
    document.getElementsByClassName("ant-table-header")[0].removeAttribute("style")

    stores.manager.currentTask.loadBatchNumber()

    const { type, groupId } = this.props
    type === "singleGroup" && stores.manager.currentTask.loadGroup(groupId)
    
  }

  render() {
    const { visible, type } = this.props
    const { currentTask: { selectedGroup, isError, filesCount, failedCount } } = stores.manager

    const { errorVisible, errorMessage } = stores.manager.currentTask
    // console.log(errorVisible,'------',this.state.errorVisible)
    setTimeout(() => {
      if(errorVisible !== this.state.errorVisible ){
        this.setState({
          errorVisible:errorVisible,
          errorMessage:errorMessage
        })
      }
    }, 100)
    
    // let acceptableFileType = "." + allowSuffix.replace(/,/g, ",.")
    let groupData = selectedGroup ? selectedGroup.files.slice() : []
    let runButtonText = `开始上传 ${this.props.info.name}`, modalWidth = getCurrentApp() === "ecs" ? 1020 : 934
    if (type === "singleGroup") {
      runButtonText = `上传数据到 ${selectedGroup && selectedGroup.name}`
      modalWidth = 750
    }

    const uploadModal = (
      <div>
        <CModal
          visible={visible}
          onCancel={() => this.closeModal("uploadModal")}
          wrapClassName="vertical-center-modal"
          className="upload-modal"
          width={modalWidth}
          maskClosable={false}>
          <div className="clearfix">
            {type === "multiGroups" && <GroupList />}
            <div className={cx(
              "uploadmodal-main-section",
              { "multi-groups": type === "multiGroups" }
            )}>
              <div className="clearfix">
                <Upload
                  multiple
                  className="pull-left"
                  beforeUpload={this.beforeUpload}>
                  <Button type="ghost" size="large"><Icon type="plus" />选择文件</Button>
                </Upload>
                <Button
                  type="primary"
                  size="large"
                  className="pull-left" style={{ marginLeft: 10 }}
                  onClick={this.onUpload}>
                  <Icon type="caret-right" />{runButtonText}
                </Button>
              </div>
              <Table
                columns={this.columns}
                dataSource={groupData}
                rowKey={record => record.file.uid}
                pagination={false}
                renderKey="id"
                scroll={{ x: true, y: 240 }}
                style={{ margin: "10px 0" }}
              />
              <div className="drag-box">
                <Dragger
                  multiple
                  beforeUpload={this.beforeUpload}>
                  <p className="ant-upload-drag-icon">
                    <Icon type="inbox" />
                  </p>
                  <p className="ant-upload-text">您可以将数据文件拖拽至此</p>
                  <p className="ant-upload-hint">当虚线变成蓝色时,说明文件已成功拖入,此时可松开鼠标!</p>
                </Dragger>
              </div>
            </div>
          </div>
        </CModal>
        <UploadProgressModal
          visible={this.state.uploading}
          onDelete={this.openDeleteModal}
          type={type}
          onReload={() => this.setState({ failedOpened: true })} />
        <ValidateModal
          onCancel={() => this.setState({ validateOpened: false })}
          visible={this.state.validateOpened}
          noReference={this.state.noReference}
          continueUpload={this.continueUpload}
        />
        <DeleteModal
          onCancel={() => this.setState({ deleteOpened: false })}
          visible={this.state.deleteOpened}
          action={this.deleteTask}
          task={this.state.targetTask} />
        <FailedModal
          onCancel={() => this.setState({ failedOpened: false })}
          visible={this.state.failedOpened && isError}
          action={this.onUpload}
          filesCount={filesCount}
          failedCount={failedCount}
        />
        <QuitModal
          action={this.closeUploadModule}
          visible={this.state.quitOpened}
          onCancel={() => this.setState({ quitOpened: false })}
        />
        <Modal
          title="错误提示"
          visible={this.state.errorVisible}
          okText="强制上传"
          cancelText="取消"
          className="my-modal"
          onOk={() => this.showErrorModal(1)}
          onCancel={() => this.showErrorModal()}
        >
          <div>{errorMessage}</div>
        </Modal>
      </div>
    )
    return <Provider {...stores}>{uploadModal}</Provider>
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/index.js